var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"report-tooltip"},[_c('div',{staticClass:"report-tooltip__button"},[_vm._v("Zobacz "),_c('IconPreview')],1),_c('div',{staticClass:"report-tooltip__content"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }